import template from './user-timesheets.html';
import controller from './user-timesheets.controller';
import './user-timesheets.styl';

let userTimesheetsComponent = {
  restrict: 'E',
  bindings: {
    userId: '<'
  },
  template,
  controller,
  controllerAs: 'vm'
};

export default userTimesheetsComponent;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-timesheets/user-timesheets.component.js
 **/